import React, { useState, useEffect } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
	AppBar,
	Box,
	Button,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemText,
	Toolbar,
	useMediaQuery,
	MenuItem,
	Typography,
	Menu,
} from "@mui/material";
import { styles } from "../styles/styles";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate, useLocation } from "react-router-dom";
import LoginOtpModal from "./Authentication/LoginOtpModel";
import "../styles/Header.css";
import { FontStyles } from "../styles/FontStyles";

function Header() {
	const [mobileOpen, setMobileOpen] = useState(false);
	const [businessMenuOpen, setBusinessMenuOpen] = useState(false);
	const [loginModalOpen, setLoginModalOpen] = useState(false);

	let userType = sessionStorage.getItem("userType");
	let token = userType ? sessionStorage.getItem("token") : localStorage.getItem("token");
	const [isLoggedIn, setIsLoggedIn] = useState(token);

	const [helpAnchorEl, setHelpAnchorEl] = useState(null);
	const [accountAnchorEl, setAccountAnchorEl] = useState(null);

	const isMobile = useMediaQuery("(max-width:1000px)");
	const navigate = useNavigate();
	const location = useLocation();
	const currentPath = location.pathname;

	useEffect(() => {
		let newToken = userType ? sessionStorage.getItem("token") : localStorage.getItem("token");
		setIsLoggedIn(!!newToken);
	}, [loginModalOpen]);

	useEffect(() => {
		if (!mobileOpen) setBusinessMenuOpen(false);
	}, [mobileOpen]);
	const [anchorEl, setAnchorEl] = useState(null);
	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};
	const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

	const handleLogout = () => {
		if (userType) {
			sessionStorage.removeItem("token");
		} else {
			localStorage.removeItem("token");
		}
		setIsLoggedIn(false);
		setAccountAnchorEl(null);
		setMobileOpen(false);
		navigate("/");
	};

	const handleLogin = () => {
		setLoginModalOpen(true);
		setMobileOpen(false);
	};

	const handleLoginModalClose = () => setLoginModalOpen(false);

	const handleBusinessMenuClick = () => setBusinessMenuOpen(!businessMenuOpen);

	const menuItems = [
		// { text: "Home", path: isLoggedIn ? "/profile/DetaliesDashbord?type=suggested-profiles" : "/" },
		{text:"Home",path:"/"},
		{ text: "About", path: "/About" },
		{ text: "Careers", path: "/Career" },
		{ text: "Contact Us", path: "/Contact" },
		{
			text: "Help",
			children: [
				{ text: "FAQ", path: "/Faq" },
				{ text: "Demo Video", path: "/Demo-Video" },
				{ text: "Contact Admin", path: "/Contact-admin" },
				{ text: "Advertisement Videos", path: "/Advertisement" }
			],
		},
		{ text: "CMD", path: "/Cmd" }
	];



	const NavButton = ({ text, path }) => (
		<Button
			sx={{
				...styles.menuitemheader,
				color: path === currentPath ? "white" : "black",
				backgroundColor: path === currentPath ? "#C1721F" : "transparent",
				"&:hover": { backgroundColor: "#C1721F", color: "white" },
				borderRadius: "5px",
				padding: { xxl: "10px" },
			}}
			onClick={() => navigate(path)}
		>
			{text}
		</Button>
	);


	const [helpMenuOpen, setHelpMenuOpen] = useState(false);

	const drawer = (
		<Box sx={{ width: { xs: "250px", sm: "300px", md: "350px" }, pt: 2 }}>
			<Box sx={{ display: "flex", justifyContent: "flex-end", px: 2, mb: 2 }}>
				<IconButton onClick={handleDrawerToggle}>
					<CloseIcon />
				</IconButton>
			</Box>
			<List>
				{menuItems.map((item) => (
					<React.Fragment key={item.text}>
						{item.children ? (
							<>
								<ListItem
									button
									onClick={() => setHelpMenuOpen((prev) => !prev)}
									sx={{ py: 1.5 }}
								>
									<ListItemText primary={item.text} />
									{helpMenuOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
								</ListItem>
								{helpMenuOpen &&
									item.children.map((child) => (
										<ListItem
											key={child.text}
											button
											sx={{ pl: 4 }}
											onClick={() => {
												navigate(child.path);
												setMobileOpen(false);
												setHelpMenuOpen(false);
											}}
										>
											<ListItemText primary={child.text} />
										</ListItem>
									))}
							</>
						) : (
							<ListItem
								button
								onClick={() => {
									navigate(item.path);
									setMobileOpen(false);
								}}
								sx={{ py: 1.5 }}
							>
								<ListItemText
									primary={item.text}
									sx={{ color: item.path === currentPath ? "#c77c2f" : "inherit" }}
								/>
							</ListItem>
						)}
					</React.Fragment>
				))}

				{isLoggedIn ? (
					<>
						<ListItem button onClick={(e) => setAccountAnchorEl(e.currentTarget)}>
							<AccountCircleIcon sx={{ mr: 1, color: "#c1721f" }} />
							<ListItemText primary="My Account" />
						</ListItem>
						<Menu anchorEl={accountAnchorEl} open={Boolean(accountAnchorEl)} onClose={() => setAccountAnchorEl(null)}>
							<MenuItem sx={styles.menuitem}>About</MenuItem>
							<MenuItem onClick={handleLogout} sx={styles.menuitem}>Logout</MenuItem>
						</Menu>
					</>
				) : (
					<ListItem button onClick={handleLogin}>
						<ListItemText primary="Login" />
					</ListItem>
				)}
			</List>
		</Box>
	);

	return (
		<AppBar position="fixed" sx={{ bgcolor: "white", height: { xs: 70, md: 90, xxl: 160 } }}>
			<Toolbar
				sx={{
					justifyContent: "space-between",
					alignItems: "center",
					height: "100%",
					width: "94%",
					margin: "0 auto",
				}}
			>

				<Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
					<Box
						component="img"
						src="/images/Frame 148.png"
						alt="Annapurna Marriages Logo"
						onClick={() => {
							navigate(isLoggedIn ? "/profile/DetaliesDashbord?type=suggested-profiles" : "/");
						}}
						sx={{
							height: { xs: 40, md: 60, xxl: 100 },
							cursor: "pointer",
						}}
					/>
				</Box>
				{isMobile ? (
					<IconButton onClick={handleDrawerToggle} sx={{ color: "black" }}>
						<MenuIcon />
					</IconButton>
				) : (
					<Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
						{menuItems.map((item) =>
							item.children ? (
								<Box
									key={item.text}
									sx={{ position: "relative" }}
									onMouseEnter={(e) => setHelpAnchorEl(e.currentTarget)}
									onMouseLeave={() => setHelpAnchorEl(null)}
								>
									<Button
										sx={{
											...styles.menuitemheader,
											borderRadius: "5px",
											padding: { xxl: "10px" },
											color: "black",
										}}
									>
										{item.text}
									</Button>
									<Menu
										sx={{ cursor: "pointer" }}
										anchorEl={helpAnchorEl}
										open={Boolean(helpAnchorEl)}
										onClose={() => setHelpAnchorEl(null)}
										MenuListProps={{
											onMouseEnter: () => setHelpAnchorEl(helpAnchorEl),
											onMouseLeave: () => setHelpAnchorEl(null),
										}}
									>
										{item.children.map((child) => (
											<MenuItem
												sx={{ ...styles.menuitem }}
												key={child.text}
												onClick={() => {
													navigate(child.path);
													setHelpAnchorEl(null);
												}}
											>
												{child.text}
											</MenuItem>
										))}
									</Menu>
								</Box>
							) : (
								<NavButton key={item.text} text={item.text} path={item.path} />
							)
						)}
						
						{isLoggedIn ? (
							<>
								<Box
									onClick={handleMenuOpen}
									sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}
								>
									<IconButton sx={{ border: "2px solid #C1721F", p: 0, width: { xxl: "70px" }, height: { xxl: "70px" } }}>
										<AccountCircleIcon fontSize="large" sx={{ color: "#C1721F", width: { xxl: "70px" }, height: { xxl: "70px" } }} />
									</IconButton>

									<Typography sx={{ ...FontStyles.headrmyAccountFont }}>
										My account
									</Typography>

									{Boolean(anchorEl) ? (
										<KeyboardArrowUpIcon sx={{ color: "black", cursor: "pointer", width: { xxl: "60px" }, height: { xxl: "60px" } }} />
									) : (
										<KeyboardArrowDownIcon sx={{ color: "black", cursor: "pointer", width: { xxl: "60px" }, height: { xxl: "60px" } }} />
									)}
								</Box>

								<Menu
									anchorEl={anchorEl}
									open={Boolean(anchorEl)}
									onClose={handleMenuClose}
									sx={{
										"& .MuiPaper-root": {
											width: {
												xs: "200px", sm: "200px", md: "200px", lg: "200px", xl: "300px", xxl: "500px"
											},
											marginTop: {
												xs: "0px", sm: "10px"
											}
										}
									}}
								>
									<MenuItem sx={{ ...styles.menuitem }} onClick={() => {
										navigate(isLoggedIn ? "/profile/DetaliesDashbord?type=suggested-profiles" : "/");
									}}>My Account</MenuItem>
									<MenuItem sx={{ ...styles.menuitem }} onClick={() => navigate("/profile/About")}>About</MenuItem>
									<MenuItem onClick={handleLogout} sx={{ ...styles.menuitem }}>Logout</MenuItem>
								</Menu>
							</>
						) : (
							<Button
								variant="contained"
								color="primary"
								onClick={handleLogin}
								sx={{
									width: "108px",
									height: "47.4px",
									borderRadius: "4px",
									padding: "10px",
									backgroundColor: "#C1721F",
									color: "white",
									"&:hover": { backgroundColor: "#C1721F" },
								}}
							>
								Login
							</Button>
						)}

					</Box>
				)}
			</Toolbar>

			<Drawer variant="temporary" anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
				{drawer}
			</Drawer>

			<LoginOtpModal open={loginModalOpen} onClose={handleLoginModalClose} />
		</AppBar>
	);
}
export default Header;

